import { NettingType } from '@g2-shared/api-client/generated/settlement-app';

export const NettingTypeLabelMapper: Record<NettingType, string> = {
  [NettingType.ALL_ALL]: 'All_and_all',
  [NettingType.FEE_COMMISSION]: 'Fee_and_commision',
  [NettingType.PRINCIPAL_PRINCIPAL]: 'Principal_and_principal',
};
